export interface ActivityToggles {
  hasLowThreshold?: boolean;
  lowThreshold?: number;
  hasPassingThreshold?: boolean;
  passingThreshold?: number;
  peerReview?: boolean;
  numOfReviews?: number;
}
